import { Utils } from "../../../common/views/Utils";
import { FileType, FileCategory } from "../../../pictures/models/PictureModel";
import { PictureUtils } from "../../../pictures/views/PictureUtilities";
import { NewLineModel } from "../../models/NewProductModel";
import { PriceDisplayType } from "../../models/ProductModel";

export type DisplayLineProps = {
    line: NewLineModel;
}

export default function DisplayLineView({ line }: DisplayLineProps) {
    const width5 = Utils.getColumnWidth(5);
    const width7 = Utils.getColumnWidth(7);
    const size = { width: 100, height: 100 };

    const imageElement = () => {
        const bytes = line.uploadPicture?.bytes;

        if (!bytes) return <></>;

        return <div className="pt-5">
            {PictureUtils.createImage2(FileType.image, bytes, FileCategory.feature, size, () => { })}
        </div>;
    }

    return <>
        <div className="ms-Grid-row">
            <div className={width5}>
                {imageElement()}
            </div>
            <div className={width7}>
                <div>Name: <b>{line.name}</b></div>
                <div className="pt-10">Code: <b>{line.code}</b></div>
                <div className="pt-10">Style: <b>{line.style}</b></div>
                <div className="pt-10">Price Display: <b>{PriceDisplayType[line.priceDisplayType]}</b></div>
            </div>
        </div>
    </>;
}